
export abstract class ICookieManagerService {
  abstract acceptCookies(): void;
  abstract deleteCookies(): void;
  abstract cookiesNoticeAccepted(): void;
}
